import api from '../../utils/service';
import { notifSend } from './notifs';

const initialState = {
  apiKeys: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_API_KEYS:
      return {
        ...state,
        apiKeys: action.payload,
      };
    case CREATE_API_KEY:
      return {
        ...state,
        apiKeys: state.apiKeys.concat(action.payload),
      };
    case DELETE_API_KEY:
      return {
        ...state,
        apiKeys: state.apiKeys.filter(({ _id }) => _id !== action.payload),
      };
    default:
      return state;
  }
}

/**
 * Rest actions
 */
export const CREATE_API_KEY = 'redux/apiKeys/CREATE_API_KEY';
export const createApiKey = (note) => async (dispatch) => {
  const result = await api.post('/api-keys', { note });
  dispatch({ type: CREATE_API_KEY, payload: result.data });
  dispatch(
    notifSend({ message: `Api Key Created, ${note || 'for general purpose'}`, dismissAfter: 4000 }),
  );
};

export const GET_API_KEYS = 'redux/apiKeys/GET_API_KEYS';
export const getApiKeys = (id) => async (dispatch) => {
  const keys = await api.get(`/api-keys/${id || ''}`);
  dispatch({ type: GET_API_KEYS, payload: keys.data.keys });
  dispatch(
    notifSend({ message: `Collected ${keys.data.keys.length} api keys`, dismissAfter: 4000 }),
  );
};

export const DELETE_API_KEY = 'redux/apiKeys/DELETE_API_KEY';
export const deleteApiKey = (id) => async (dispatch) => {
  const result = await api.delete(`/api-keys/${id || ''}`);
  if (result.data.deleted) {
    dispatch({ type: DELETE_API_KEY, payload: id });
    dispatch(notifSend({ message: 'Api Key Deleted', dismissAfter: 4000 }));
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/apiKeys.js